import Swiper from 'swiper'
import {Pagination, Autoplay, Navigation, EffectFade, Mousewheel} from 'swiper/modules'
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

export class Slider {
  constructor() {
    document.querySelectorAll('*[slider]').forEach(slider => {
      this.registerSlider(slider)
    })
  }

  registerSlider(slider) {

    /** default config **/
    let config = {
      loop: false,
      modules: []
    }

    /** variables from view **/
    let name = slider.getAttribute('data-slider')
    let per_view = slider.getAttribute('per-view')
    let per_view_sm = slider.getAttribute('per-view-sm')
    let per_view_md = slider.getAttribute('per-view-md')
    let per_view_xs = slider.getAttribute('per-view-xs')
    let modules = slider.getAttribute('modules')

    /** extra config **/
    const extraConfig = slider.getAttribute('extra')
    if (JSON.parse(modules).includes('navigation')) {
      config.modules.push(Navigation)
      config.navigation = {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      }
    }

    if (JSON.parse(modules).includes('pagination')) {
      config.modules.push(Pagination)
      config.pagination = {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="swiper-pagination-bullet"></span>'
        }
      }
    }

    if (JSON.parse(modules).includes('autoplay')) {
      config.modules.push(Autoplay)
      config.autoplay = {
        delay: 4000,
        disableOnInteraction: false,
        waitForTransition: false,
      }
    }

    if (JSON.parse(modules).fade) {
      config.modules.push(EffectFade)
      config.effect = 'fade'
      config.fadeEffect = {
        crossFade: true
      }
    }

    if (JSON.parse(modules).mousewheel) {
      config.modules.push(Mousewheel)
      config.mousewheel = {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      }
    }

    const swiper = new Swiper('.' + name, {
      ...config,
      ...JSON.parse(extraConfig),
      wrapperClass: name + '-wrapper',
      gap: 20,
      breakpoints: {
        300: {
          slidesPerView: per_view_xs,
        },
        480: {
          slidesPerView: per_view_sm,
        },
        768: {
          slidesPerView: per_view_md,
        },
        1024: {
          slidesPerView: per_view,
        }
      }
    })
  }
}
